import { render } from "./DragHandle.vue?vue&type=template&id=6f923180&scoped=true"
import script from "./DragHandle.vue?vue&type=script&lang=js"
export * from "./DragHandle.vue?vue&type=script&lang=js"

import "./DragHandle.vue?vue&type=style&index=0&id=6f923180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f923180"]])

export default __exports__